import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import type { ActionSchema } from '@wix/cli-app-definitions';
import {
  composeValidations,
  useValidation,
  uuidValidation,
} from '../../../../dev-center/components/validations/index.js';
import { useWixCliAstroBi } from '../../../../bi/index.js';

export const NavigateToPage: FC<{
  onActionSelected: (action: ActionSchema) => void;
}> = ({ onActionSelected }) => {
  const bi = useWixCliAstroBi();
  const [pageId, setPageId] = useState<string>();

  const validatePageId = useValidation(
    composeValidations([
      [uuidValidation, 'Page id has to be in the format of a uuid'],
    ])
  );

  useEffect(() => {
    if (pageId) {
      onActionSelected({
        navigateToPage: {
          pageId,
        },
      });
    }
  }, [pageId, onActionSelected]);

  return (
    <TextInput
      label={'What is the unique id of the page?'}
      onSubmit={(pageId) => {
        bi.cliFlowStepAnswered({
          question: 'What is the unique id of the page?',
          questionKey:
            'generate_command.dashboard_menu_plugin.what_to_do.navigate_to_page.choose_page.other.choose_page_id',
          answer: pageId,
        });
        setPageId(pageId);
      }}
      validate={validatePageId}
    />
  );
};
